<template>
  <div
    class="fc-event-main"
    :style="{ color: info.event.textColor, backgroundColor: info.event.backgroundColor }"
    ref="eventElement"
    @mouseenter="tooltipInstance && tooltipInstance.show()"
    @mouseleave="tooltipInstance && tooltipInstance.hide()"
  >
    <div class="fc-event-main-frame">
      <div class="fc-event-time">{{ info.timeText }}</div>
      <div class="fc-event-title-container">
        <div class="fc-event-title fc-sticky">{{ info.event.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import tippy from 'tippy.js' // Import Tippy.js

export default {
  props: {
    info: Object,
    getRoundName: Function
  },
  data () {
    return {
      tooltipInstance: null
    }
  },
  mounted () {
    // Select all elements with the 'data-tippy-root' attribute
    const elements = document.querySelectorAll('[data-tippy-root]')

    elements.forEach(element => {
      element.remove()
    })

    this.tooltipInstance = tippy(this.$refs.eventElement, {
      content: this.createTooltipContent(),
      allowHTML: true,
      theme: 'light',
      interactive: true,
      trigger: 'manual',
      placement: 'right',
      animation: false,
      hideOnClick: false,
      appendTo: () => document.body
    })
  },
  methods: {
    createTooltipContent () {
      const event = this.info.event

      return `
        <div class="event-tooltip-content" style="background-color: ${event.backgroundColor}">
          <div class="text-center px-2 py-1 font-weight-bold"><span class="bg-white text-dark font-weight-bold px-1 rounded">${event.extendedProps.venue?.name ? event.extendedProps.venue.name + ' - ' : ''}${this.info.timeText}</span></div>
          <div class="d-flex flex-column js-event-teams">

            <div class="px-2 py-1 bg-white font-weight-bold text-dark d-flex justify-content-between align-items-center font-size-sm"><span>${event.extendedProps.teamA?.name ?? 'TBD'}</span></div>
            <div class="px-2 py-1 bg-white font-weight-bold text-dark d-flex justify-content-between align-items-center font-size-sm"><span>${event.extendedProps.teamB?.name ?? 'TBD'}</span></div>
          </div>
          <div class="px-2 py-1 font-weight-bold d-flex justify-content-between" style="color: ${event.textColor}"><span class="mr-2">${event.extendedProps.league.name}</span> <span>${this.getRoundName(event.extendedProps.round, event.extendedProps.playoffRound)}</span></div>
       </div>
      `
    }
  },
  destroyed () {
    console.log('Destroying tooltip instance')
    // Clean up tooltip instance when component is destroyed
    if (this.tooltipInstance) {
      this.tooltipInstance.destroy()
    }
  }
}
</script>

<style>
.event-tooltip-content {
  min-width: 130px;
  border-radius: 5px;
  font-size: 12px;
}
</style>
